import * as Yup from "yup";

export const InstituteValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email is not valid")
    .required("Email is required!")
    .nullable(),

  name: Yup.string().required("Institute Name is required!").nullable(),
  registeredAddress: Yup.string()
    .required("Registered Address is required!")
    .nullable(),
  contactPerson: Yup.string()
    .required("Contact Person is required!")
    .nullable(),
  phoneNumber: Yup.string()
    .min(10, "Phone Number should not be more or less then 10 digits")
    .max(10, "Phone Number should not be more or less then 10 digits")
    .required("Phone Number is required!")
    .nullable(),
});

export const BranchValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email is not valid")
    .required("Email is required!")
    .nullable(),

  name: Yup.string().required("Branch Name is required!").nullable(),
  boardId: Yup.number().required("Board is required!").nullable(),
  classRooms: Yup.array().required("Please select class!").nullable(),
  registeredAddress: Yup.string()
    .required("Registered Address is required!")
    .nullable(),
  contactPerson: Yup.string()
    .required("Contact Person is required!")
    .nullable(),
  phoneNumber: Yup.string()
    .min(10, "Phone Number should not be more or less then 10 digits")
    .max(10, "Phone Number should not be more or less then 10 digits")
    .required("Phone Number is required!")
    .nullable(),
});

export const SectionValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email is not valid")
    .required("Email is required!")
    .nullable(),
  name: Yup.string().required("Section Name is required!").nullable(),
  branchId: Yup.string().required("Branch is required!").nullable(),
  branchClassRoomId: Yup.number().required("Class is required!").nullable(),
  sectionSubjects: Yup.array().required("Please select subjects!").nullable(),
  sectionExams: Yup.array().required("Please select exams!").nullable(),
  registeredAddress: Yup.string()
    .required("Registered Address is required!")
    .nullable(),
  contactPerson: Yup.string()
    .required("Contact Person is required!")
    .nullable(),
  phoneNumber: Yup.string()
    .min(10, "Phone Number should be 10 digits")
    .max(10, "Phone Number should be 10 digits")
    .required("Phone Number is required!")
    .nullable(),
});
export const TeacherValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email is not valid")
    .required("Email is required!")
    .nullable(),
  fullName: Yup.string().required("Name is required!").nullable(),
  phoneNumber: Yup.string()
    .min(10, "Phone Number should be 10 digits")
    .max(10, "Phone Number should be 10 digits")
    .required("Phone Number is required!")
    .nullable(),
  branchId: Yup.number().required("Branch is required!").nullable(),
  expertise: Yup.array().required("Expertise is required").nullable(),
  // password: Yup.string().required("Password is required!").nullable(),
});

export const StudentValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Email is not valid")
    .required("Email is required!").nullable(),
  firstName: Yup.string().required("Name is required!").nullable(),
  phoneNumber: Yup.string()
    .min(10, "Phone Number should be 10 digits")
    .max(10, "Phone Number should be 10 digits")
    .required("Phone Number is required!").nullable(),
  dob: Yup.date().required("DOB is required!").nullable(),
  rollNumber: Yup.string().required('Roll Number is required'),
});

export const LiveClassValidationSchema = Yup.object().shape({
  title: Yup.string().required("Title is required!").nullable(),
  date: Yup.string().required("Date is required!").nullable(),
  duration: Yup.string().required("Duration is required!").nullable(),
  startTime: Yup.string().required("Start Time is required!").nullable(),
  branchId: Yup.number().required("Branch is required!").nullable(),
  sectionIds: Yup.array().required("Section required!").nullable(),
  classRoomId: Yup.number().required("Classroom is required!").nullable(),
  tutorIds: Yup.number().required("Tutor required!").nullable(),
});

export const UpdatePasswordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .required('New Password is required!').nullable(),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), ""], 'Confirm password must match')
    .required('Confirm Password is required!').nullable()
});
